// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.notification.ResendSigningEmailsWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { ResendSigningEmailsWebApiHandler_resendOnlineSigningEmails } from '@zg-rentals/ts-leasing-client';

import type { ResendOnlineSigningEmailsRequestDto } from '@zg-rentals/ts-leasing-client';

export interface ResendSigningEmailsWebApiHandler_resendOnlineSigningEmails_Args {
  postData: ResendOnlineSigningEmailsRequestDto;
}

export type ResendSigningEmailsWebApiHandler_resendOnlineSigningEmails_Options = UseMutationOptions<
  void,
  unknown,
  ResendSigningEmailsWebApiHandler_resendOnlineSigningEmails_Args
>;

/**
 * resend signing emails
 */
export const useResendSigningEmailsWebApiHandler_resendOnlineSigningEmails = ({
  httpClient,
  ...options
}: Omit<ResendSigningEmailsWebApiHandler_resendOnlineSigningEmails_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ResendSigningEmailsWebApiHandler_resendOnlineSigningEmails_Args) =>
      ResendSigningEmailsWebApiHandler_resendOnlineSigningEmails(args.postData, httpClient),
  });
};
